import { useTranslation } from "react-i18next";

import Button from "src/components-v2/Button";
import Modal from "src/components-v2/Modal";
import { ModalProps } from "src/components-v2/Modal";

import { PropsWithDataQaid } from "src/types/componentProps";

type CancelTransactionModalProps = Omit<ModalProps, "onClose"> &
  PropsWithDataQaid<{
    /**
     * Set show or hide modal
     */
    showModal: boolean;

    /**
     * Modal toggle function
     */
    toggle: () => void;

    /**
     * Prop passed submit onCancel function
     */
    onCancelTransaction: () => void;

    /**
     * Prop isLoading for set disabled/activated on the buttons
     */
    isLoading: boolean;
  }>;

function CancelTransactionModal(props: CancelTransactionModalProps) {
  const { showModal, toggle, onCancelTransaction, isLoading, "data-qaid": dataQaid, ...rest } = props;
  const { t } = useTranslation("transaction");

  return (
    <Modal
      size="small"
      withoutCloseButton
      title={t("receipt.cancel-transaction.title")}
      show={showModal}
      onClose={toggle}
      closeOnOverlay
      data-qaid={`${dataQaid}-modal-cancel-transaction`}
      {...rest}
    >
      <p className="u-mb-6">{t("receipt.cancel-transaction.description")}</p>
      <div className="u-flex u-justify-around u-items-center u-gap-1">
        <Button
          outline
          activated={isLoading}
          disabled={isLoading}
          onClick={onCancelTransaction}
          data-qaid={`${dataQaid}-modal-button-cancel`}
        >
          {t("receipt.cancel-transaction.submit-cancel")}
        </Button>
        <Button disabled={isLoading} onClick={toggle} data-qaid={`${dataQaid}-modal-button-back`}>
          {t("receipt.cancel-transaction.back")}
        </Button>
      </div>
    </Modal>
  );
}

export default CancelTransactionModal;
